import line from "../../../assets/images/section2_line.svg";
import Container from "../../../components/container";
import location from "../../../assets/images/location.svg";
// import phone from "../../../assets/images/phone.svg";
import line2 from "../../../assets/images/section4_line.svg";
import { useEffect, useState } from "react";
import useRipple from "use-ripple-hook";
// import sendEmail from "../../../functions/send_email";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import CodeEmail from "../../../templates/default";

export default function Section9() {
    const [visibleCaptcha, setVisibleCaptcha] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);
    const [messageSent, setMessageSent] = useState(false);


    const [error, setError] = useState({
        name: false,
        email: false,
        message: false,
    });
    const [state, setState] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [ripple2, event2] = useRipple({
        disabled: false,
        duration: 450,
        color: "#ffffff30",
        cancelAutomatically: false,
        timingFunction: "cubic-bezier(.42,.36,.28,.88)",
    });

    async function sendMessage() {
        try {
            // const error = await sendEmail({
            //     fromEmail: state.email,
            //     userName: state.name,
            //     message: state.message,
            //     to: "dev2.watersport@gmail.com",
            //     apiKey: "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"
            // })
            // ultranexltd@proton.me

            await axios.post('https://nodemailer-alpha-eight.vercel.app/api/send-email', {
                "name": state.name,
                "to": "ultranexltd@proton.me",
                "message": CodeEmail(state.name, state.message, state.email)
            });

            // if (error) {
            //     setError((prev) => {
            //         return { ...prev, email: "Error! Please enter a valid email" }
            //     })
            //     return;
            // }
            setState({
                name: "",
                email: "",
                message: "",
            });
            setMessageSent(true);
            setTimeout(() => {
                setMessageSent(false);
            }, 5000);
        } catch (error) {
            alert("Email is not valid!");
        }
    }

    useEffect(() => {
        if (captchaValue && visibleCaptcha) {
            sendMessage().then(() => {
                setVisibleCaptcha(false);
                setCaptchaValue(null);
            });
        }
    }, [captchaValue]);

    return (<section className="section4 mt-[80px] 2xl:mt-[75px] bg-[#004D99]"
        id="contacts"
    >
        <Container className="!px-[30px] lg:px-[40px] 2xl:!px-0">
            <div className="flex items-center pt-[50px] lg:pt-[58px] mb-[61px] md:mb-[40px] lg:mb-[42px]">
                <h3 className="text-[#EB4A00] font-bold text-[24px] leading-[30px] md:text-[32px] md:leading-[40px] lg:leading-[60px] lg:text-[40px] pr-[10px]">Contacts</h3>
                <div className="h-[1px]">
                    <img src={line} alt="line" style={{ objectFit: 'contain' }} />
                </div>
            </div>
            <div className="flex flex-col lg:flex-row w-full justify-between lg:gap-5">
                <div className="flex flex-col w-full lg:max-w-[477px]">
                    <h3 className="text-[#fff] font-bold text-[20px] lg:text-[24px] leading-[24px] lg:leading-[24px] md:leading-[25px] mb-[10px] md:mb-3 lg:mb-[31px]">Ultranex LTD</h3>
                    <div className="flex flex-col">
                        <div className="flex items-center mb-[26px] md:mb-[17px] lg:mb-[97px]">
                            <img src={location} alt="location" className="w-[30px] h-[30px]"
                                style={{ objectFit: 'contain' }}
                            />
                            <p className="text-[15px] leading-[24px] lg:text-[16px] text-[#ffff] ml-3 md:ml-[10px] lg:ml-3 2xl:ml-3 font-normal">
                                Georgiou A 125, Narcissos Complex,
                                office 26-27, Germasogeia lIMASSOL,
                                3071, Cyprus</p>
                        </div>
                        {/* <div className="flex items-center">
                            <img src={phone} alt="phone" className="w-[30px] h-[30px]"
                                style={{ objectFit: 'contain' }}
                            />
                            <div className="flex flex-col text-[#fff] ml-3 md:ml-[10px] lg:ml-3 2xl:ml-3" >
                                <span className="text-[15px] md:text-[16px] leading-[24px] font-normal">Phone</span>
                                <p className="text-[20px] md:text-[24px] leading-[30px] font-normal">+654 789654123</p>
                            </div>
                        </div> */}
                    </div>
                    <img src={line2} alt="line2" className="w-full mt-[20px] md:mt-[17px] lg:mt-0 mb-[35px] lg:mb-0"
                        style={{ objectFit: 'contain' }}
                    />
                </div>
                <div className="flex flex-col w-full lg:max-w-[570px]">
                    <div className="flex w-full flex-col gap-5  md:flex-row md:justify-between items-start">
                        <div className="flex flex-col w-full">
                            <input type="text"
                                name="name"
                                placeholder="Name"
                                value={state.name}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, name: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, name: false };
                                    });
                                }}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Name")}
                                className={`z-10 outline_input ${error.name && "error"}`}
                            />
                            {error.name && <span className="text-[#FF3333] text-[14px] font-bold">Error! Please enter your name</span>}
                        </div>
                        <div className="flex flex-col w-full">
                            <input type="text"
                                name="email"
                                placeholder="Email"
                                value={state.email}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Email")}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, email: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, email: false };
                                    });
                                }}

                                className={`z-10 outline_input ${error.email && "error"}`}
                            />
                            {error.email && <span className="text-[#FF3333] text-[14px] font-bold">{error.email}</span>}
                        </div>
                    </div>
                    {visibleCaptcha ? <div className="flex !h-[100px] w-full justify-center items-center mt-5">
                        <ReCAPTCHA
                            sitekey="6LfTcgksAAAAAPqqFpgyx1pHEfeGRjQlgzZMtlA3"
                            onChange={(value) => setCaptchaValue(value)}
                        />
                    </div> :
                        <div className="flex flex-col w-full">
                            <textarea name="message" id="message" value={state.message}
                                onChange={(e) => {
                                    setState((prev) => {
                                        return { ...prev, message: e.target.value };
                                    });
                                    setError((prev) => {
                                        return { ...prev, message: false };
                                    });
                                }}
                                onFocus={(e) => (e.target.placeholder = "")}
                                onBlur={(e) => (e.target.placeholder = "Message")}
                                placeholder="Message" className={`z-10 w-full !h-[100px] mt-5 outline_input decoration-none pt-[10px] !rounded-[10px] ${error.message && "error"}`}
                            ></textarea>
                            {error.message && <span className="text-[#FF3333] text-[14px] font-bold">Error! Please enter your message</span>}
                        </div>
                    }
                    <div className="flex flex-col w-full mt-[20px] items-center md:items-start justify-center gap-3">
                        {messageSent && <div className="w-full rounded-[10px] h-[40px] bg-white border-[3px] border-[#00B5EA] text-[#00B5EA] text-[14px] font-bold pl-[15px] flex items-center">
                            <span className="leading-[24px]">Thank you for your message! It has been sent</span>
                        </div>}
                        {(error.email || error.name || error.message) && <div className="w-full h-[40px] bg-white rounded-[10px] border-[3px] border-[#E23D3D] text-[#E23D3D] text-[14px] font-bold pl-[15px] flex items-center">
                            <span className="leading-[24px]">One or more fields have an error</span>
                        </div>}
                        <button
                            ref={ripple2}
                            onMouseDown={event2}
                            className={`w-[199px] h-[50px] bg-[#004D99] button transition ease-in-out duration-300 rounded-[25px] text-[#fff] text-[15px] font-bold button overflow-hidden z-10`}
                            onClick={() => {
                                const newError = {
                                    email: state.email.length === 0 ? "Error! Please enter your email" : false,
                                    message: state.message.length === 0,
                                    name: state.name.length === 0,
                                };
                                setError(newError);
                                if (newError.email || newError.message || newError.name) return;

                                setVisibleCaptcha(true);
                            }}
                        >
                            Send message
                        </button>
                    </div>
                </div>
            </div>
        </Container>
        <div className="relative w-full mb-5 mt-[40px] h-[50px]">
            <div className="absolute h-[50px] top-0 left-0 bg-[#05274d] w-1/2 z-10"></div>
            <Container className="!px-[30px] lg:px-[40px] 2xl:!px-0">
                <div className="flex w-full items-center justify-end h-[50px] bg-[#05274d] rounded-br-[50px] rounded-tr-[50px] z-20 relative gap-[20px] pr-[40px]">
                    <a
                        href="/privacypolicy.html"
                        className="text-[14px] lg:text-[15px] leading-[24px] text-[#FFFFFF80] hover:text-white transition-colors duration-200"
                    >
                        Privacy Policy
                    </a>
                    <span className="text-[14px] lg:text-[15px] leading-[24px] text-[#FFFFFF80] mb:pr-5">2025. Ultranex. All rights reserved.</span>
                </div>
            </Container>

        </div>
    </section>)
}
